import React from "react";
import { Image, Button, Icon } from "semantic-ui-react";

import "./ClientDBItems.scss";

export function ClientDBItems(props) {
  const { client } = props;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(client._id);
    alert("Client ID copiado al portapapeles");
  };

  return (
    <>
      <div className="client-item">
        <div className="client-item__info">
          <Image src={`${client.miniature}`} />
          <div>
            <h1>{client.client}</h1>
            <h2>{client.title}</h2>
            <p>
              {client._id}{" "}
              <Button icon size="mini" onClick={copyToClipboard}>
                <Icon name="copy" />
              </Button>
            </p>
          </div>
        </div>
        <div className="client-item__buttons">
          <Button
            icon
            fluid
            color={"green"}
            onClick={() => {
              const urlWithId = `${client.url}?id=${client._id}`;
              window.location.href = urlWithId;
            }}
          >
            {"ENTRAR"}
          </Button>
        </div>
      </div>
    </>
  );
}
